export const getStateName = (name: string): string => {
  const state = name.toLowerCase()

  switch (state) {
    case 'alberta':
    case 'ab':
      return 'Alberta'
    case 'british columbia':
    case 'bc':
      return 'British Columbia'
    case 'manitoba':
    case 'mb':
      return 'Manitoba'
    case 'new brunswick':
    case 'nb':
      return 'New Brunswick'
    case 'newfoundland and labrador':
    case 'nl':
      return 'Newfoundland and Labrador'
    case 'northwest territories':
    case 'nt':
    case 'nwt':
      return 'Northwest Territories'
    case 'nova scotia':
    case 'ns':
      return 'Nova Scotia'
    case 'nunavut':
    case 'nu':
      return 'Nunavut'
    case 'ontario':
    case 'on':
      return 'Ontario'
    case 'prince edward island':
    case 'pe':
      return 'Prince Edward Island'
    case 'quebec':
    case 'québec':
    case 'qc':
      return 'Quebec'
    case 'saskatchewan':
    case 'sk':
      return 'Saskatchewan'
    case 'yukon':
    case 'yt':
    case 'yu':
      return 'Yukon'
    default:
      throw new Error('State not found: ' + state)
  }
}